import { useState, useEffect, useCallback } from 'react';
import { axiosApi } from '../../api/setupApi';

const useAccount = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUserProfile = useCallback(async () => {
    const userId = localStorage.getItem('userId');
    if (!userId) {
      setError('User ID not found');
      setUserData(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const { data } = await axiosApi.get('/auth/getAll_users');

      const normalizedId = userId.toString();
      const matchedUser = Array.isArray(data)
        ? data.find((user) => {
            if (!user) return false;
            const idMatches =
              user.id !== undefined && user.id !== null && user.id.toString() === normalizedId;
            const codeMatches =
              user.code !== undefined && user.code !== null && user.code.toString() === normalizedId;
            const userIdMatches =
              user.userId !== undefined && user.userId !== null && user.userId.toString() === normalizedId;
            return idMatches || codeMatches || userIdMatches;
          })
        : null;

      if (!matchedUser) {
        setError('User not found');
        setUserData(null);
        return;
      }

      const sanitized = {
        id: matchedUser.id,
        code: matchedUser.code,
        name: matchedUser.name || matchedUser.username || '',
        username: matchedUser.username || matchedUser.name || '',
        email: matchedUser.email || matchedUser.Email || '',
        role: matchedUser.role,
      };

      setUserData(sanitized);

      if (sanitized.name || sanitized.username) {
        localStorage.setItem('username', sanitized.name || sanitized.username);
      }
      if (sanitized.email) {
        localStorage.setItem('email', sanitized.email);
      }
    } catch (err) {
      console.error('Failed to fetch user list for profile:', err);
      setError(err.response?.data?.message || err.message || 'Unknown error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUserProfile();
  }, [fetchUserProfile]);

  return { userData, loading, error, refetch: fetchUserProfile };
};

export default useAccount;
